import React from "react";
import "../../assets/styles/local/ColorTag.css";
function ColorTag({ tagList }) {
  return (
    <div>
      <div className="pro-part-col-tag-con">
        {tagList?.slice(0, 4)?.map((color, id) => {
          return (
            <div
              key={id}
              className="pro-part-col-tag"
              style={{ background: color.color }}></div>
          );
        })}
      </div>
      <div className="pro-part-col-tag-con mt-1">
        {tagList?.slice(4, 8)?.map((color, id) => {
          return (
            <div
              key={id}
              className="pro-part-col-tag"
              style={{ background: color.color }}></div>
          );
        })}
      </div>
      <div className="pro-part-col-tag-con mt-1">
        {tagList?.slice(8, 11)?.map((color, id) => {
          return (
            <div
              key={id}
              className="pro-part-col-tag"
              style={{ background: color.color }}></div>
          );
        })}
        {tagList?.length >= 12 ? (
          <div className="pro-part-col-extra">+10</div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
export default ColorTag;
